<template>
  <div class="expert-tool-undo">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="showDialog = true"
          color="primary"
          class="ml-4"
          fab
          text
          small
          right
          v-on="on"
          v-bind="attrs"
        >
          <v-icon :color="$color.coro.purple">mdi-undo</v-icon>
        </v-btn>
      </template>
      <span>{{ $ucfirst($t('dss.undo')) }}</span>
    </v-tooltip>
    <v-dialog v-model="showDialog" width="600px">
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{ $ucfirst($t('expertTool.areYouSureYouWantToRevert')) }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <v-btn @click="confirm" x-large text class="ml-4" color="primary">
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn @click="showDialog = false" x-large text class="ml-4">
            {{ $ucfirst($t('general.close', { catalog:  'app_mobile' })) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Component ExpertToolUndo.vue
 *
 * @module ExpertToolUndo
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/views/ExpertTool/ExpertToolUndo.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export default {
  name: 'ExpertToolClose',
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {},
  methods: {
    confirm() {
      this.$emit('confirm');
      this.showDialog = false
    }
  },
};
</script>
